// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"799061d9","455":"646e6cc5"}[chunkId] + ".chunk.js";
};